import React from 'react';

const PaymentRow = ({ tenant }) => {
    return (
        <tr className="">
            <td className="px-4 py-3">
                <div className="flex flex-col">
                    <span className="font-medium">{tenant.house_number}</span>
                    <span className="text-gray-500 text-sm">{tenant.apartment}</span>
                </div>
            </td>
            <td className="px-4 py-3">{tenant.user || 'N/A'}</td>
            <td className="px-4 py-3">{tenant.phone_number || 'N/A'}</td>
            <td className="px-4 py-3">
                {tenant.month
                    ? tenant.month.charAt(0).toUpperCase() + tenant.month.slice(1)
                    : "N/A"}
                , {tenant.year || "N/A"}
            </td>
            <td className="px-4 py-3">KSh {tenant?.opening_balance_amount?.toLocaleString('en-us') || '0'}</td>
            <td className="px-4 py-3">KSh {tenant?.rent_amount?.toLocaleString('en-us') || '0'}</td>
            <td className="px-4 py-3">KSh {tenant?.expected_amount?.toLocaleString('en-us') || '0'}</td>
            <td className="px-4 py-3">KSh {tenant?.opening_balance_due?.toLocaleString('en-us') || '0'}</td>
            <td className="px-4 py-3">KSh {tenant?.rent_balance?.toLocaleString('en-us') || '0'}</td>
            <td className="px-4 py-3">KSh {tenant?.opening_balance_paid?.toLocaleString('en-us') || '0'}</td>
            <td className="px-4 py-3">KSh {tenant?.rent_paid?.toLocaleString('en-us') || '0'}</td>
            <td className="px-4 py-3">
                <span className={`px-2 py-1 rounded-full text-xs ${tenant.status === 'paid' ? 'bg-green-100 text-green-800' :
                    tenant.status === 'partial' ? 'bg-yellow-100 text-yellow-800' :
                        'bg-red-100 text-red-800'
                    }`}>
                    {tenant.status || 'unpaid'}
                </span>
            </td>
        </tr>
    );
};

export default PaymentRow;